import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import {
  TestimonialsContainer,
  TestimonialsGrid,
  TestimonialCard,
  StudentImage,
} from "../pages/Testimonialsection";
import MainSection from "../components/MainSection";
import TestimonialsImage from "../images/testimonials.png";
import { InView } from "react-intersection-observer";

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem 0;
`;

const PageNumber = styled.button`
  background: none;
  border: none;
  color: #1a467a;
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem;
  margin: 0 0.5rem;
  transition: 0.3s ease-in-out;
`;

const Ellipsis = styled.span`
  padding: 0.5rem;
`;

const TestimonialsOverviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 80px;
  padding: 5rem 4rem;
  animation: fade-in-up 0.3s;

  @media (min-width: 768px) and (max-width: 819px) {
    padding: 2.5rem 3rem;
    gap: 40px;
  }

  @media (max-width: 767px) {
    padding: 2.5rem 1rem;
    gap: 40px;
  }

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

const OverviewTitle = styled.h3`
  font-size: 24px;
  color: #302e2e;
  font-weight: 700;
  margin-bottom: 16px;
`;

const OverviewDetail = styled.p`
  font-size: 16px;
  line-height: 25px;
  color: #302e2e;
  text-align: justify;
`;

const TestimonialsImg = styled.img`
  height: 290px;
  object-fit: contain;
  @media (max-width: 1024px) {
    width: 100%;
    object-fit: cover;
  }
  @media (max-width: 480px) {
    width: 100%;
    object-fit: contain;
  }
`;

const Testimonials = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(
          "https://education-project-deploy-01c3d0549de6.herokuapp.com/api/testimonials"
        );
        setTestimonials(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchTestimonials();
  }, []);

  const handleClick = (event) => {
    setCurrentPage(Number(event.target.id));
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(testimonials.length / itemsPerPage); i++) {
    pages.push(i);
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = testimonials.slice(indexOfFirstItem, indexOfLastItem);

  const paginationItems = [];
  let ellipsisLeft = false;
  let ellipsisRight = false;

  for (let i = 1; i <= pages.length; i++) {
    if (
      i === currentPage ||
      i === 1 ||
      i === pages.length ||
      (i === currentPage - 1 && currentPage !== 2) ||
      (i === currentPage + 1 && currentPage !== pages.length - 1)
    ) {
      paginationItems.push(
        <PageNumber key={i} id={i} onClick={handleClick}>
          {i}
        </PageNumber>
      );
    } else if (i < currentPage && !ellipsisLeft) {
      paginationItems.push(<Ellipsis key={i}>...</Ellipsis>);
      ellipsisLeft = true;
    } else if (i > currentPage && !ellipsisRight) {
      paginationItems.push(<Ellipsis key={i}>...</Ellipsis>);
      ellipsisRight = true;
    }
  }

  return (
    <>
      <MainSection
        bannerTxt="Testimonials"
        nonNavigablePaths={["study-abroad", "Company"]}
      />
      <InView triggerOnce threshold={0.5}>
        {({ inView, ref }) => (
          <TestimonialsOverviewContainer
            ref={ref}
            style={{ animationPlayState: inView ? "running" : "paused" }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <OverviewTitle>What people say about us?</OverviewTitle>
              <OverviewDetail>
                Hear from our students who have successfully pursued their dreams of studying abroad with our expert guidance. As a trusted education consultancy, we've helped countless students navigate their journey to international education. These testimonials showcase how we've supported students in choosing the right universities, preparing applications, securing scholarships, and making their study abroad dreams a reality. From visa assistance to pre-departure guidance, our comprehensive support has made the complex process of studying abroad smooth and successful for our students.
              </OverviewDetail>
            </div>
            <TestimonialsImg src={TestimonialsImage} alt="Testimonials Img" />
          </TestimonialsOverviewContainer>
        )}
      </InView>
      <TestimonialsContainer>
        <TestimonialsGrid>
          {currentItems.map((testimonial) => (
            <TestimonialCard key={testimonial.name}>
              <StudentImage src={testimonial.image} alt={testimonial.name} />
            </TestimonialCard>
          ))}
        </TestimonialsGrid>
      </TestimonialsContainer>
      <Pagination>{paginationItems}</Pagination>
    </>
  );
};

export default Testimonials;
